import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TeachersTrainingAidForm from './forms/TeachersTrainingAidForm';
import TeachersTrainingAidList from './lists/TeachersTrainingAidList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {Tooltip} from "react-tippy";
import CheckBox from "../form/CheckBox";
import {postData} from "../../utils/request";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../utils/formatters";
import Icon from "../form/Icon";
import TextInput from "../form/TextInput";
import {ifCompletedInput} from "../../utils/other";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";

class TeachersTrainingAidEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Oktatási segédanyagok"
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <TeachersTrainingAidList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Oktatási segédanyag"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <TeachersTrainingAidForm {...this.props} />
                </Editor>
                <Other>
                    {
                        this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.article_list
                        &&
                        <Box
                            theme="default"
                            header="Cikkek"
                        >
                            <SelectorGrid
                                columns={{
                                    "headline": {
                                        header: 'Cím',
                                        width: 2,
                                        sortable: true,
                                        filterable: true,
                                    },
                                }}
                                name="article_list"
                                listfieldlabel="headline"
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                                {...this.props.getFieldProps("article_list")}
                            />
                        </Box>
                    }
                </Other>
        </Fragment>;
    }
}

export default createEditor({componentName: "TeachersTrainingAid", WrappedComponent: TeachersTrainingAidEditor});
